import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getAuth, signOut } from 'firebase/auth';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-profilecard',
  templateUrl: './profilecard.component.html',
  styleUrls: ['./profilecard.component.scss'],
})
export class ProfilecardComponent implements OnInit {
  @Input() uid: string = '';
  @Input() planName: string = '';
  @Input() planColor: string = '';

  currentuser: any = {};

  constructor(
    private firestoreService: FirestoreService,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.getProfileDetails();
  }

  ngOnChanges() {
    if (this.uid) {
      // intentionally left — existing behaviour preserved
    }
  }

  async getProfileDetails() {
    await this.firestoreService
      .getDocumentByIDFrom('users-list', this.uid)
      .then((resp: any) => {
        if (resp) {
          this.currentuser = resp;
        }
      });
  }

  navigate() {
    // Workers should NOT access the profile page
    if (this.currentuser.role === 'worker') {
      this.router.navigateByUrl('/business/Dashboard');
      return;
    }
    if (this.currentuser.role === 'Premium User' || this.currentuser.role === 'Client') {
      this.router.navigateByUrl('/user/profile');
    } else if (this.currentuser.role === 'Contractor') {
      this.router.navigateByUrl('/contractor/profile');
    } else if (this.currentuser.role === 'servicemanager') {
      this.router.navigateByUrl('/servicemanager/profile');
    } else if (this.currentuser.role === 'productmanager') {
      this.router.navigateByUrl('/productmanager/profile');
    } else if (this.currentuser.role === 'admin' || this.currentuser.role === 'Director') {
      this.router.navigateByUrl('/admin');
    } else {
      this.router.navigateByUrl('/business/profile');
    }
  }

  userSignOut() {
    this.authService.userSignOut();
  }
}